import Box from "@mui/material/Box";
import type { ReactNode } from "react";

/** A square tile holding a brand mark or an icon, left of a name. */
export default function LogoBadge({ children, size = 40 }: { children: ReactNode; size?: number }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "action.hover",
      }}
    >
      {children}
    </Box>
  );
}
